/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import styled, { css } from "styled-components";
import { FiraSansBold } from "components/Text";
import globalStyles from "globalStyles";
import Colors from "constants/Colors";

const Dialog = styled.div`
  position: fixed;
  z-index: 100;
  padding-top: 15vh;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgba(255, 255, 255, 0.4);

  ${({ canShow }) =>
    canShow
      ? css`
          display: block;
        `
      : `display: none;`}
`;

const DialogBody = styled.div`
  background-color: ${Colors.WHITE};
  margin: auto;
  padding: 0px;
  box-shadow: 0px 1px 5px 2px
    ${globalStyles.components.dialog.dialog_body.box_shadow};
  width: ${({width}) => width || '80%'};
  height: auto;
  min-height: 100px;
  border-radius: 4px;

  @media (max-width: 80%) {
    margin: auto;
  }
`;

const DialogIcon = styled.div`
  height: 5px;
  display: block;
  width: 100%;
  ${({ pink }) =>
    pink === "exclamation"
      ? css`
          color: ${globalStyles.components.dialog.dialog_icon.color};
        `
      : `display: ${globalStyles.components.dialog.dialog_icon.display};`}

  font-size: 22px;
  svg {
    float: left;
  }
`;

const DialogText = styled.p`
  display: block;
  color: ${globalStyles.components.dialog.dialog_text.color};
  font-weight: ${FiraSansBold};
  font-family: "Fira Sans", sans-serif;
  font-size: 14px;
  text-transform: uppercase;
  float: left;
  margin: 0px;
  margin-left: 8px;
  margin-top: 1px;
`;

export { Dialog, DialogBody, DialogIcon, DialogText };
